import { useState, useEffect } from "react";
import Header from "../Header/Header1";
import "./bot.scss";
import { Button, FormLabel } from "@mui/material";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TablePagination,
} from "@mui/material";
import Loader from "../Loader";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import consts from "../../constant";
import usercalls from "../../Axios";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { io } from "socket.io-client";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: 2,
};

const Simpletrade = () => {
  const [tab, setTab] = useState(0);
  const [tradeLoading, setTradeLoading] = useState(false);
  const [activeTrades, setActiveTrades] = useState([]);
  const [tradeHistory, setTradeHistory] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [cancelTradeId, setCancelTradeId] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const { state } = useLocation();
  const [pairs, setPairs] = useState([]);
  const [form, setForm] = useState({
    pair: "",
    order_type: "market",
    side: "buy",
    quantity: "",
    price: "",
    conditional_price: "",
    conditional_value: "",
    conditional_type: "",
    trailing_type: "",
    trailing_value: "",
    time_out: "",
    leverage: "",
    total: 0,
  });
  const path = usercalls();
  const getPairLabel = (pairItem) =>
    typeof pairItem === "string"
      ? pairItem
      : pairItem?.pair || pairItem?.symbol || pairItem?.name || pairItem?.label;
  const getPairValue = (pairItem) =>
    typeof pairItem === "string"
      ? pairItem
      : pairItem?.pair || pairItem?.symbol || pairItem?.name || pairItem?.value;
  const normalizedSearch = search.trim().toLowerCase();
  const filteredPairs = pairs.filter((pairItem) => {
    if (!normalizedSearch) return true;
    const label = String(getPairLabel(pairItem) || "").toLowerCase();
    const value = String(getPairValue(pairItem) || "").toLowerCase();
    return label.includes(normalizedSearch) || value.includes(normalizedSearch);
  });

  const getPair = async () => {
    try {
      const url = `${consts.BackendUrl}/bots/get-trading-pairs`;
      const payload = {
        market: state?.market_code || state?.market,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setPairs(result?.result || []);
      } else {
        setPairs([]);
      }
    } catch (err) {
      setPairs([]);
    }
  };
  useEffect(() => {
    const socket = io(consts?.socketUrl, {
      path: "/socket",
    });
    socket.on("connect", () => {
      socket.emit("join", {
        room: localStorage.getItem("use"),
      });
      console.log("socket connected");
    });

    socket.on("simple_active_trade", (data) => {
      try {
        console.log(data, "socket simple_active_trade");
        getActiveTrades();
        getHistoryTrades();
      } catch (e) {
        console.log(e);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    getPair();
  }, []);

  const getEffectivePrice = (data, rates) =>
    Number(data.order_type === "market" ? rates?.last || 0 : data.price || 0);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (name === "pair") {
      getCurrencyRates(value);
      setSearch("");
    }
    setForm((p) => ({ ...p, [name]: value }));
  };

  const validate = (data) => {
    const isBlank = (value) =>
      value === undefined || value === null || String(value).trim() === "";
    const toNumber = (value) => Number(value);
    const isPositiveNumber = (value) => {
      const num = toNumber(value);
      return Number.isFinite(num) && num > 0;
    };

    if (isBlank(data.pair)) return "Pair is required";
    if (!data.order_type || !["market", "limit"].includes(data.order_type))
      return "Order type must be market or limit";
    if (!data.side || !["buy", "sell"].includes(data.side))
      return "Side must be buy or sell";
    if (!isPositiveNumber(data.quantity))
      return "Quantity must be greater than 0";

    if (data.order_type === "limit") {
      if (!isPositiveNumber(data.price))
        return "Price is required and must be greater than 0";
    }

    const hasConditionalField =
      !isBlank(data.conditional_price) ||
      !isBlank(data.conditional_type) ||
      !isBlank(data.conditional_value);

    if (hasConditionalField) {
      if (isBlank(data.conditional_price))
        return "Conditional price is required";
      if (!isPositiveNumber(data.conditional_price))
        return "Conditional price must be greater than 0";
      if (!["bid", "ask", "last"].includes(data.conditional_type))
        return "Conditional type must be bid, ask, or last";
      if (
        !["less_or_equal", "greater_or_equal"].includes(data.conditional_value)
      )
        return "Conditional value must be less_or_equal or greater_or_equal";
    }

    const hasTrailingField =
      !isBlank(data.trailing_type) || !isBlank(data.trailing_value);

    if (hasTrailingField) {
      if (!["value", "percent"].includes(data.trailing_type))
        return "Trailing type must be value or percent";
      if (!isPositiveNumber(data.trailing_value))
        return "Trailing value must be greater than 0";
      if (
        data.trailing_type === "percent" &&
        toNumber(data.trailing_value) > 100
      )
        return "Trailing percent must be less than or equal to 100";
    }

    if (
      !isBlank(data.time_out) &&
      (!Number.isInteger(toNumber(data.time_out)) ||
        toNumber(data.time_out) <= 0)
    )
      return "Time out must be a positive integer";
    if (
      !isBlank(data.leverage) &&
      !["cross", "isolated"].includes(data.leverage)
    )
      return "Leverage must be cross or isolated";

    return null;
  };

  const handleSubmit = async () => {
    const err = validate(form);
    if (err) return toast.error(err);

    const effectivePrice = getEffectivePrice(form, currencyRates);
    const total = effectivePrice * Number(form.quantity || 0);
    if (!effectivePrice || effectivePrice <= 0) {
      return toast.error(
        form.order_type === "market"
          ? "Current market price is unavailable for this pair"
          : "Price is required and must be greater than 0",
      );
    }

    setSubmitLoading(true);
    try {
      const url = `${consts.BackendUrl}/bots/create-simple-trade`;
      const payload = {
        pair: form.pair,
        order_type: form.order_type,
        side: form.side,
        quantity: Number(form.quantity),
        price: Number(effectivePrice),
      };

      payload.total = Number(total.toFixed(12));

      const hasConditionalField =
        String(form.conditional_price || "").trim() ||
        String(form.conditional_type || "").trim() ||
        String(form.conditional_value || "").trim();

      if (hasConditionalField) {
        payload.conditional_price = Number(form.conditional_price);
        payload.conditional_value = form.conditional_value;
        payload.conditional_type = form.conditional_type;
      }

      const hasTrailingField =
        String(form.trailing_type || "").trim() ||
        String(form.trailing_value || "").trim();

      if (hasTrailingField) {
        payload.trailing_type = form.trailing_type;
        payload.trailing_value = Number(form.trailing_value);
      }

      if (String(form.time_out || "").trim()) {
        payload.time_out = Number(form.time_out);
      }

      if (String(form.leverage || "").trim()) {
        payload.leverage = form.leverage;
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        toast.success(result?.message || "Trade created successfully");
        setOpenTrade(false);
        setForm({
          pair: "",
          order_type: "market",
          side: "buy",
          quantity: "",
          price: "",
          conditional_price: "",
          conditional_value: "",
          conditional_type: "",
          trailing_type: "",
          trailing_value: "",
          time_out: "",
          leverage: "",
          total: 0,
        });
        getTrades();
      } else {
        toast.error(result?.message || "Failed to create trade");
      }
    } catch (e) {
      console.error(e);
      toast.error("Cannot create trade");
    } finally {
      setSubmitLoading(false);
    }
  };

  const [openTrade, setOpenTrade] = useState(false);

  const getActiveTrades = async () => {
    try {
      setTradeLoading(true);
      const url = `${consts.BackendUrl}/bots/get-simple-trade-details?page=${page + 1}&limit=${rowsPerPage}`;
      const payload = {
        id: state?.id,
        type: "active",
        limit: rowsPerPage,
        offset: page * rowsPerPage,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setActiveTrades(result?.result?.docs || []);
        setActiveTotal(result?.result?.totalDocs || 0);
      } else {
        setActiveTrades([]);
        setActiveTotal(0);
      }
      setTradeLoading(false);
    } catch (err) {
      setActiveTrades([]);
      setActiveTotal(0);
      setTradeLoading(false);
    }
  };

  const getHistoryTrades = async () => {
    try {
      setTradeLoading(true);
      const url = `${consts.BackendUrl}/bots/get-simple-trade-details?page=${page + 1}&limit=${rowsPerPage}`;
      const payload = {
        id: state?.id,
        type: "history",
        limit: rowsPerPage,
        offset: page * rowsPerPage,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setTradeHistory(result?.result?.docs || []);
        setHistoryTotal(result?.result?.totalDocs || 0);
      } else {
        setTradeHistory([]);
        setHistoryTotal(0);
      }
      setTradeLoading(false);
    } catch (err) {
      setTradeHistory([]);
      setHistoryTotal(0);
      setTradeLoading(false);
    }
  };

  const getTrades = async () => {
    if (tab === 0) {
      getActiveTrades();
    } else {
      getHistoryTrades();
    }
  };
  const [currencyRates, setCurrencyRates] = useState({});

  useEffect(() => {
    const effectivePrice = getEffectivePrice(form, currencyRates);
    const total = effectivePrice * Number(form.quantity || 0);
    setForm((prev) => ({
      ...prev,
      total: total > 0 ? Number(total.toFixed(12)) : "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.order_type, form.price, form.quantity, currencyRates?.last]);

  const getCurrencyRates = async (pair) => {
    try {
      const url = `https://api.3commas.io/public/api/ver1/accounts/currency_rates?market_code=kucoin&pair=${pair}`;
      const { data } = await axios.get(url);
      if (data) {
        setCurrencyRates(data);
      } else {
        setCurrencyRates({});
      }
    } catch (err) {
      setCurrencyRates({});
    }
  };

  const handleCancelTrade = async () => {
    if (!cancelTradeId) return;
    setCancelLoading(true);
    try {
      const url = `${consts.BackendUrl}/bots/cancel-simple-trade`;
      const payload = { uuid: cancelTradeId };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        toast.success(result?.message || "Trade cancelled successfully");
        setOpenConfirm(false);
        setCancelTradeId(null);
        getTrades();
      } else {
        toast.error(result?.message || "Failed to cancel trade");
      }
    } catch (e) {
      console.error(e);
      toast.error("Cannot cancel trade");
    } finally {
      setCancelLoading(false);
    }
  };

  const handleConfirmCancel = (tradeUuid) => {
    setCancelTradeId(tradeUuid);
    setOpenConfirm(true);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [activeTotal, setActiveTotal] = useState(0);
  const [historyTotal, setHistoryTotal] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return value;
  };

  useEffect(() => {
    getTrades();
  }, [tab, page, rowsPerPage]);

  return (
    <div className="market-full ar3 page_align" style={{ maxHeight: "100vh" }}>
      <Header />

      <Toaster />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="bot_dash contain-width ">
            <div className="display-2">
              <h3 className="">Simple Trade</h3>
              <div className="bot_comman_btn">
                <Button onClick={() => setOpenTrade(true)}>Create Trade</Button>
              </div>
            </div>
          </div>
          <div className="mt-20">
            <div className="custom_table box_bdr mt-20">
              {/* Tabs Header Styled Like Assets */}
              {/* <div className="h_flx flex-wrap gap-10">
                                <h3>Trades</h3>

                                <Tabs
                                    value={tab}
                                    onChange={(e, v) => setTab(v)}
                                    sx={{
                                        minHeight: "auto",
                                        "& .MuiTabs-indicator": {
                                            backgroundColor: "#566FFF",
                                            height: "2px"
                                        }
                                    }}
                                >
                                    <Tab
                                        label="Active Trade"
                                        sx={{
                                            textTransform: "none",
                                            minHeight: "auto",
                                            fontWeight: 600
                                        }}
                                    />
                                    <Tab
                                        label="Trade History"
                                        sx={{
                                            textTransform: "none",
                                            minHeight: "auto",
                                            fontWeight: 600
                                        }}
                                    />
                               

                       
                                </Tabs>
                            </div> */}

              <div className=" display-1 flex-wrap gap-10">
                <h3
                  onClick={() => setTab(0)}
                  className={tab === 0 ? "active assetTab" : "assetTab"}
                >
                  Active Trade
                </h3>

                <h3
                  onClick={() => setTab(1)}
                  className={tab === 1 ? "active assetTab" : "assetTab"}
                >
                  Trade History
                </h3>
              </div>
              {tab === 0 && (
                <div className="custom_table box_bdr mt-20">
                  <div className="h_flx">
                    <h3>Active Trade</h3>
                  </div>

                  <TableContainer sx={{ marginBottom: "10px" }}>
                    <Table sx={{ minWidth: 650 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>orderTime</TableCell>
                          <TableCell>Order ID</TableCell>
                          <TableCell>Pairs</TableCell>
                          <TableCell>Order Type</TableCell>
                          <TableCell>Side</TableCell>
                          <TableCell>Order Price</TableCell>
                          <TableCell>StopLimit Price</TableCell>
                          <TableCell>Order Quantity</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {tradeLoading ? (
                          <TableRow>
                            <TableCell colSpan={10}>
                              <div className="inline-loader">
                                <Loader />
                              </div>
                            </TableCell>
                          </TableRow>
                        ) : activeTrades?.length > 0 ? (
                          activeTrades.map((row, i) => (
                            <TableRow key={i} className="tr_row">
                              <TableCell>
                                {new Date(row.createdAt).toLocaleString()}
                              </TableCell>
                              <TableCell>
                                {row.trade_id?.slice(0, 8) +
                                  "...." +
                                  row.trade_id?.slice(-8) || "-"}
                              </TableCell>
                              <TableCell>{row.pair}</TableCell>
                              <TableCell>
                                {row?.order_type?.toUpperCase() || "-"}
                              </TableCell>
                              <TableCell
                                style={{
                                  color:
                                    row.side === "buy" ? "#00C853" : "#FF5252",
                                }}
                              >
                                {row?.side?.toUpperCase() || "-"}
                              </TableCell>
                              <TableCell>{row.price || "-"}</TableCell>
                              <TableCell>
                                {row?.conditional_price
                                  ? row?.conditional_price || "-"
                                  : "-"}
                              </TableCell>
                              <TableCell>{row?.quantity || "-"}</TableCell>

                              <TableCell
                                style={{
                                  color:
                                    row.status === "failed"
                                      ? "#FF5252"
                                      : row.status === "Completed"
                                        ? "#00C853"
                                        : row.status === "Pending"
                                          ? "#ecb213"
                                          : "var(--clr-font)",
                                }}
                              >
                                {row.status || "-"}
                              </TableCell>
                              <TableCell>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  color="error"
                                  onClick={() =>
                                    handleConfirmCancel(row.trade_id)
                                  }
                                >
                                  Cancel
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={10} align="center">
                              No Active Trades
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    <TablePagination
                      component="div"
                      count={activeTotal || (activeTrades || []).length}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPageOptions={[10]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                </div>
              )}

              {tab === 1 && (
                <div className="custom_table box_bdr mt-20">
                  <div className="h_flx">
                    <h3>Trade History</h3>
                  </div>

                  <TableContainer sx={{ marginBottom: "10px" }}>
                    <Table sx={{ minWidth: 650 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Created At</TableCell>
                          <TableCell>Trade ID</TableCell>
                          <TableCell>Pair</TableCell>
                          <TableCell>Order Type</TableCell>
                          <TableCell>Side</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell>Status</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {tradeLoading ? (
                          <TableRow>
                            <TableCell colSpan={10}>
                              <div className="inline-loader">
                                <Loader />
                              </div>
                            </TableCell>
                          </TableRow>
                        ) : tradeHistory?.length > 0 ? (
                          tradeHistory.map((row, i) => (
                            <TableRow key={i} className="tr_row">
                              <TableCell>
                                {new Date(row.createdAt).toLocaleString()}
                              </TableCell>
                              <TableCell>
                                {formatValue(row?.trade_id)}
                              </TableCell>
                              <TableCell>{row.pair}</TableCell>
                              <TableCell>
                                {row?.order_type?.toUpperCase() || "-"}
                              </TableCell>
                              <TableCell
                                style={{
                                  color:
                                    row.side === "buy" ? "#00C853" : "#FF5252",
                                }}
                              >
                                {row?.side?.toUpperCase() || "-"}
                              </TableCell>
                              <TableCell>
                                {formatValue(row?.quantity)}
                              </TableCell>
                              <TableCell>{formatValue(row?.price)}</TableCell>

                              <TableCell
                                style={{
                                  color: ["failed", "cancelled"].includes(
                                    String(row?.status || "").toLowerCase(),
                                  )
                                    ? "#FF5252"
                                    : String(
                                          row?.status || "",
                                        ).toLowerCase() === "completed"
                                      ? "#00C853"
                                      : String(
                                            row?.status || "",
                                          ).toLowerCase() === "pending"
                                        ? "#ecb213"
                                        : "var(--clr-font)",
                                }}
                              >
                                {formatValue(row?.status)}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={10} align="center">
                              No Trade History
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    <TablePagination
                      component="div"
                      count={historyTotal || (tradeHistory || []).length}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPageOptions={[10]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                </div>
              )}
            </div>
          </div>
        </Grid>
      </Grid>

      <Modal
        open={openTrade}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">Create Trade</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={() => setOpenTrade(false)}
            />
          </div>

          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            mt={2}
            className=""
            style={{ maxHeight: "400px", overflow: "auto" }}
          >
            <FormLabel
              size="small"
              sx={{ color: "var(--clr-font)", fontSize: "12px", mt: 0 }}
            >
              Current Price : {currencyRates?.last ? currencyRates.last : 0}{" "}
              {currencyRates?.symbol}
            </FormLabel>
            {pairs && pairs.length > 0 ? (
              <FormControl fullWidth required>
                <InputLabel id="pair-label">Pair (required)</InputLabel>
                <Select
                  className="bot-select"
                  fullWidth
                  name="pair"
                  value={form.pair}
                  onChange={handleFormChange}
                  labelId="pair-label"
                  id="pair"
                  label="Pair (required)"
                  required
                >
                  <MenuItem value="">Select Pair</MenuItem>
                  <TextField
                    size="small"
                    placeholder="Search pairs"
                    className="bot-input"
                    fullWidth
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => e.stopPropagation()}
                    sx={{ width: "90%", margin: "10px auto", display: "block" }}
                  />
                  {filteredPairs.map((p, idx) => {
                    const label = getPairLabel(p);
                    const value = getPairValue(p);
                    return (
                      <MenuItem key={idx} value={value}>
                        {label}
                      </MenuItem>
                    );
                  })}
                  {filteredPairs.length === 0 && (
                    <MenuItem disabled>No pairs found</MenuItem>
                  )}
                </Select>
              </FormControl>
            ) : (
              <TextField
                label="Pair (required)"
                name="pair"
                fullWidth
                className="bot-input"
                value={form.pair}
                onChange={handleFormChange}
                required
              />
            )}

            <FormControl fullWidth required>
              <InputLabel id="order-type-label">
                Order Type (required)
              </InputLabel>
              <Select
                className="bot-select"
                name="order_type"
                value={form.order_type}
                onChange={handleFormChange}
                labelId="order-type-label"
                id="order_type"
                label="Order Type (required)"
                required
              >
                <MenuItem value="market">Market</MenuItem>
                <MenuItem value="limit">Limit</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth required>
              <InputLabel id="side-label">Side (required)</InputLabel>
              <Select
                className="bot-select"
                name="side"
                value={form.side}
                onChange={handleFormChange}
                labelId="side-label"
                id="side"
                label="Side (required)"
                required
              >
                <MenuItem value="buy">Buy</MenuItem>
                <MenuItem value="sell">Sell</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Quantity (required)"
              name="quantity"
              type="text"
              fullWidth
              className="bot-input"
              value={form.quantity}
              onChange={handleFormChange}
              required
            />

            {form.order_type === "limit" && (
              <TextField
                label="Price (required)"
                name="price"
                type="text"
                fullWidth
                className="bot-input"
                value={form.price}
                onChange={handleFormChange}
                required
              />
            )}
            <TextField
              label="Total"
              name="total"
              type="text"
              fullWidth
              className="bot-input"
              value={form.total}
              InputProps={{ readOnly: true }}
            />
            <TextField
              label="Conditional Price (optional)"
              name="conditional_price"
              type="text"
              fullWidth
              className="bot-input"
              value={form.conditional_price}
              onChange={handleFormChange}
            />

            <FormControl fullWidth>
              <InputLabel id="conditional-value-label">
                Conditional Value (optional)
              </InputLabel>
              <Select
                className="bot-select"
                name="conditional_value"
                value={form.conditional_value}
                onChange={handleFormChange}
                labelId="conditional-value-label"
                id="conditional_value"
                label="Conditional Value (optional)"
              >
                <MenuItem value="">Conditional Value</MenuItem>
                <MenuItem value="less_or_equal">Less or Equal</MenuItem>
                <MenuItem value="greater_or_equal">Grater or Equal</MenuItem>
              </Select>
            </FormControl>
            {/* 
            <FormControl fullWidth>
              <InputLabel id="trailing-type-label">
                Trailing Type (optional)
              </InputLabel>
              <Select
                className="bot-select"
                name="trailing_type"
                value={form.trailing_type}
                onChange={handleFormChange}
                labelId="trailing-type-label"
                id="trailing_type"
                label="Trailing Type (optional)"
              >
                <MenuItem value="">Trailing Type</MenuItem>
                <MenuItem value="value">value</MenuItem>
                <MenuItem value="percent">percent</MenuItem>
              </Select>
            </FormControl>

            {form.trailing_type && (
              <TextField
                label="Trailing Value"
                name="trailing_value"
                type="text"
                fullWidth
                className="bot-input"
                value={form.trailing_value}
                onChange={handleFormChange}
              />
            )} */}

            <FormControl fullWidth>
              <InputLabel id="conditional-type-label">
                Conditional Type
              </InputLabel>
              <Select
                className="bot-select"
                name="conditional_type"
                value={form.conditional_type}
                onChange={handleFormChange}
                labelId="conditional-type-label"
                id="conditional_type"
                label="Conditional Type"
              >
                <MenuItem value="">Conditional Type</MenuItem>
                <MenuItem value="ask">ask</MenuItem>
                <MenuItem value="bid">bid</MenuItem>
                <MenuItem value="last">last</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="timeout-label">Timeout</InputLabel>
              <Select
                className="bot-select"
                name="time_out"
                value={form.time_out}
                onChange={handleFormChange}
                labelId="timeout-label"
                id="time_out"
                label="Timeout"
              >
                <MenuItem value="">Select Time</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={15}>15</MenuItem>
              </Select>
            </FormControl>

            {/* <FormControl fullWidth>
              <InputLabel id="leverage-label">Leverage</InputLabel>
              <Select
                className="bot-select"
                name="leverage"
                value={form.leverage}
                onChange={handleFormChange}
                labelId="leverage-label"
                id="leverage"
                label="Leverage"
              >
                <MenuItem value="">Leverage</MenuItem>
                <MenuItem value="cross">Cross</MenuItem>
                <MenuItem value="isolated">Isolated</MenuItem>
              </Select>
            </FormControl> */}
          </Box>

          <div className="bot_comman_btn display-3 mt-20">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={submitLoading}
            >
              {submitLoading ? "Submitting..." : "Submit"}
            </Button>
          </div>
        </Box>
      </Modal>
      <Modal open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <Box sx={style}>
          <div className="p-20">
            Are you sure you want to cancel this trade?
          </div>

          <div className="display-2">
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={() => {
                  setOpenConfirm(false);
                  setCancelTradeId(null);
                }}
              >
                No
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color="error"
                onClick={handleCancelTrade}
                disabled={cancelLoading}
              >
                {cancelLoading ? "Cancelling..." : "Yes"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default Simpletrade;
